import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { deepOrange } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { useAuth, useRoutes } from '../../hooks';
import { logout, toggleDarkMode } from '../../store';
import { State } from '../../store/reducers';
import logo from '../../assets/tete-leo.png';

const useStyles = makeStyles((theme) => ({
  avatar: {
    color: theme.palette.getContrastText(deepOrange[500]),
    width: theme.spacing(4),
    height: theme.spacing(4),

    cursor: 'pointer',
  },
  img: {
    width: '100%',
    height: '100%',
  },
  bigAvatar: {
    color: theme.palette.getContrastText(deepOrange[500]),
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  container: {
    width: 250,
  },
  infos: {
    display: 'flex',
    padding: theme.spacing(2),
  },
  names: {
    flex: 1,
    marginLeft: theme.spacing(1),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
}));

export const AuthBox: React.FC = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { paths, navigate } = useRoutes();
  const dispatch = useDispatch();
  const darkMode = useSelector((state: State) => state.settings.darkMode);
  const { auth, isLoggedIn } = useAuth();
  const [role = ''] = auth?.roles || [];

  const navigateToLogin = navigate(paths.login.path);

  const handleOnLogout = useCallback(() => {
    dispatch(logout());
    navigateToLogin();
  }, [navigateToLogin, dispatch]);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <div>
      <div className={classes.avatar} onClick={handleClick}>
        <img src={logo} className={classes.img} alt="logo" />
      </div>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Paper className={classes.container}>
          {isLoggedIn && (
            <>
              <div className={classes.infos}>
                <div className={classes.bigAvatar}>
                  <img src={logo} className={classes.img} alt="logo" />
                </div>
                <div className={classes.names}>
                  <Typography>
                    {auth?.firstName} {auth?.lastName}
                  </Typography>
                  <Typography variant="caption">{role}</Typography>
                </div>
              </div>
              <Divider />
            </>
          )}
          <FormControlLabel
            className={classes.form}
            checked={darkMode}
            control={<Switch color="primary" />}
            label="Mode Sombre"
            labelPlacement="start"
            onChange={() => dispatch(toggleDarkMode())}
          />

          <div className={classes.action}>
            <Button color="secondary" onClick={handleOnLogout}>
              {isLoggedIn ? 'Déconnexion' : 'Connexion'}
            </Button>
          </div>
        </Paper>
      </Popover>
    </div>
  );
};

export default AuthBox;
